<template>
  <div class="policy-page">
    <trsShopBreadcrumb
      class="policy-page__breadcrumb"
      :breadcrumbList="breadcrumbList"
      :skip="true"
    />
    <div class="policy-content">
      <p class="policy-content__date">Effective Date: June 10, 2026</p>

      <p class="policy-text">
        This Privacy Policy describes how your personal information is collected, used, and shared when you visit or make a purchase from shop.tarazon.com (the "Site").
      </p>

      <section class="policy-section">
        <h3 class="policy-section__heading">Personal Information We Collect</h3>
        <p class="policy-text">
          When you visit the Site, we automatically collect certain information about your device, including information about your web browser, IP address, time zone, and some of the cookies installed on your device.
        </p>
        <p class="policy-text">
          Additionally, as you browse the Site, we collect information about the web pages or products you view, the websites or search terms that referred you to the Site, and information about how you interact with the Site.
        </p>
        <p class="policy-text">
          We refer to this automatically collected information as "Device Information".
        </p>
        <p class="policy-text">We collect Device Information using:</p>
        <ul class="policy-list policy-list--dot">
          <li>Cookies – data files placed on your device that often include an anonymous unique identifier.</li>
          <li>Log Files – records of activities occurring on the Site, including IP address, browser type, internet service provider, referring/exit pages, and timestamps.</li>
          <li>Web Beacons, Tags, and Pixels – electronic technologies used to record browsing behavior.</li>
        </ul>
      </section>

      <section class="policy-section">
        <h3 class="policy-section__heading">Order Information</h3>
        <p class="policy-text">
          When you make a purchase or attempt to make a purchase through the Site, we collect certain information from you, including:
        </p>
        <ul class="policy-list policy-list--dot">
          <li>Name</li>
          <li>Billing Address</li>
          <li>Shipping Address</li>
          <li>Payment Information</li>
          <li>Email Address</li>
          <li>Phone Number</li>
        </ul>
        <p class="policy-text">
          We refer to this information as "Order Information".
        </p>
      </section>

      <section class="policy-section">
        <h3 class="policy-section__heading">How We Use Your Personal Information</h3>
        <p class="policy-text">We use the Order Information we collect to:</p>
        <ul class="policy-list policy-list--square">
          <li>Processing and fulfilling orders.</li>
          <li>Arranging shipping and delivery.</li>
          <li>Providing invoices and order confirmations.</li>
          <li>Communicating with customers.</li>
          <li>Preventing fraudulent transactions.</li>
          <li>Providing product updates, promotions, and marketing communications where permitted.</li>
        </ul>
        <p class="policy-text">We use Device Information to:</p>
        <ul class="policy-list policy-list--square">
          <li>Detecting potential risks and fraud.</li>
          <li>Improving and optimizing our website.</li>
          <li>Analyzing customer browsing behavior.</li>
          <li>Evaluating marketing effectiveness.</li>
        </ul>
      </section>

      <section class="policy-section">
        <h3 class="policy-section__heading">Sharing Your Personal Information</h3>
        <p class="policy-text">
          We may share your Personal Information with trusted third-party service providers that help us operate our website, process payments, arrange shipping, analyze traffic, and improve our services.
        </p>
        <p class="policy-text">
          We may also disclose your Personal Information when required by law or when necessary to protect our legal rights.
        </p>
      </section>

      <section class="policy-section">
        <h3 class="policy-section__heading">Behavioural Advertising</h3>
        <p class="policy-text">
          We may use your Personal Information to provide targeted advertisements or marketing communications that may be of interest to you.
        </p>
        <p class="policy-text">
          You may opt out through the advertising platforms you use.
        </p>
      </section>

      <section class="policy-section">
        <h3 class="policy-section__heading">Do Not Track</h3>
        <p class="policy-text">
          Please note that we do not alter our Site's data collection practices when we receive a Do Not Track signal from your browser.
        </p>
      </section>

      <section class="policy-section">
        <h3 class="policy-section__heading">Your Rights</h3>
        <p class="policy-text">
          Depending on your location and applicable laws, you may have the right to:
        </p>
        <ul class="policy-list policy-list--square">
          <li>Access your personal information.</li>
          <li>Correct inaccurate information.</li>
          <li>Request deletion of your information.</li>
          <li>Restrict or object to certain processing activities.</li>
          <li>To exercise these rights, please contact us at <a href="mailto:sales@tarazon.cn" class="policy-link">sales@tarazon.cn</a>.</li>
        </ul>
      </section>

      <section class="policy-section">
        <h3 class="policy-section__heading">Data Retention</h3>
        <p class="policy-text">
          We retain Order Information for our business records unless you request its deletion, subject to applicable legal requirements.
        </p>
      </section>

      <section class="policy-section">
        <h3 class="policy-section__heading">Changes to This Policy</h3>
        <p class="policy-text">
          We may update this Privacy Policy from time to time to reflect changes in our business practices, legal requirements, or operational needs.
        </p>
      </section>

      <section class="policy-section">
        <h3 class="policy-section__heading">Minors</h3>
        <p class="policy-text">
          The Site is not intended for individuals under the age of 18.
        </p>
      </section>

      <section class="policy-section">
        <h3 class="policy-section__heading">Contact Us</h3>
        <p class="policy-text">
          If you have any questions regarding this Privacy Policy, please contact us:
        </p>
        <p class="policy-text">
          Email: <a href="mailto:sales@tarazon.cn" class="policy-link">sales@tarazon.cn</a>
        </p>
      </section>
    </div>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import trsShopBreadcrumb from '@/components/layout/shopping/breadcrumb.vue';

export default {
  name: 'trsPrivacyPolicy',
  mixins: [Mixin],
  components: {
    trsShopBreadcrumb
  },
  data() {
    let v = this;
    return {
      breadcrumbList: [
        {
          name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006562'),
          path: '/index'
        },
        {
          name: 'PRIVACY POLICY',
          path: '/trsPrivacyPolicy'
        }
      ]
    };
  },
};
</script>

<style scoped lang="less">
.policy-page {
  width: 1200px;
  margin: 0 auto;
}

.policy-page__breadcrumb {
  margin: 0 auto;
  width: 1200px;
}

.policy-content {
  background-color: #ffffff;
  margin-bottom: 20px;
  padding: 32px 40px 40px;
  color: #333;
  font-family: Arial, 'Microsoft YaHei', sans-serif;
  line-height: 1.8;
}

.policy-content__date {
  margin: 0 0 20px;
  font-size: 14px;
  color: #666;
}

.policy-section {
  margin-bottom: 24px;

  &:last-child {
    margin-bottom: 0;
  }
}

.policy-section__heading {
  margin: 0 0 12px;
  font-size: 16px;
  font-weight: 700;
  color: #000;
  line-height: 1.5;
}

.policy-text {
  margin: 0 0 12px;
  font-size: 14px;
  color: #333;
  text-align: left;

  &:last-child {
    margin-bottom: 0;
  }
}

.policy-list {
  margin: 0 0 12px;
  font-size: 14px;
  color: #333;

  li {
    margin-bottom: 6px;
    line-height: 1.7;

    &:last-child {
      margin-bottom: 0;
    }
  }
}

// Word 原文圆点列表（•）
.policy-list--dot {
  padding-left: 0;
  list-style: none;

  li {
    position: relative;
    padding-left: 16px;

    &::before {
      content: '\2022';
      position: absolute;
      left: 0;
      top: 0;
      font-size: 14px;
      line-height: 1.7;
      color: #333;
    }
  }
}

// Word 原文 Wingdings 方块列表
.policy-list--square {
  padding-left: 0;
  list-style: none;

  li {
    position: relative;
    padding-left: 20px;

    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 0.62em;
      width: 6px;
      height: 6px;
      background-color: #333;
    }
  }
}

.policy-link {
  color: #333;
  text-decoration: none;

  &:hover {
    color: #89b92a;
    text-decoration: underline;
  }
}
</style>
